/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';
import AppContext from '../../../Context/AppContext';
import requestAxios from '../../../util/requestAxios';
import Pie from '../Wheel/Pie';
import Confetti from '../Confetti/Confetti';
import Wheel from '../Wheel/Wheel';
import ContentFinal from './components/FinalStep1/FinalStep1';
import Fnav from './components/Fnav/Fnav';
import initialState from './components/initialState';
import './Step12.css';

export default class Step12 extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    async componentDidMount() {
        const { checkUserSession, updateUserStepId,changeLoading } = this.context;
        const currUser = checkUserSession();
        const userState = await updateUserStepId();
        window.addEventListener('resize', this.resize.bind(this));
        // this.setState({changeStepIndex:this.props.changeStepIndex})
        if (!userState || userState.assessmentId == null) {
            this.setState({
                loadError:
                    'Could not load your assessment. Check your connection and open the app again.',
            });
            return;
        }
        const result = await requestAxios({
            url: `areas/GetQuestions/${userState.assessmentId}`,
            token: currUser.token,
        });
        if (result.error || !Array.isArray(result.data)) {
            this.setState({
                loadError:
                    'Could not load your assessment. Check your connection and open the app again.',
            });
            return;
        }
        Promise.resolve({ data: result.data })
            .then((result) => {
                const questions = [];
                result.data.forEach((quest) => {
                    quest.TotalScore = quest.questions.reduce(
                        (a, b) => a + Number(b.score),
                        0
                    );
                    questions.push(quest);
                });

                // Dev preview: /steps-v2?preview=fun-final → Fun complete screen
                //              /steps-v2?preview=fun-start  → Fun Q1, Fs 1–6 filled
                let previewIndex = 0;
                const areaIdx =
                    userState.areaId > 6 ? 6 : userState.areaId || 0;
                const area = questions[areaIdx];
                let previewQuestion = area?.questions
                    ? area.questions.filter((x) => x.score > 0).length
                    : 0;
                try {
                    const preview = new URLSearchParams(
                        window.location.search
                    ).get('preview');
                    if (preview === 'fun-final' || preview === 'fun') {
                        previewIndex = 6;
                        previewQuestion = 10;
                        questions.forEach((f) => {
                            f.questions.forEach((q) => {
                                if (q.score == null || Number(q.score) === 0) {
                                    q.score = 5;
                                }
                            });
                            f.TotalScore = f.questions.reduce(
                                (a, b) => a + Number(b.score),
                                0
                            );
                        });
                    } else if (
                        preview === 'fitness' ||
                        preview === 'fitness-questions' ||
                        preview === 'questions'
                    ) {
                        // Mid-assessment question UI (Fitness Q3)
                        previewIndex = 0;
                        previewQuestion = 2;
                        const f0 = questions[0];
                        if (f0) {
                            f0.questions.forEach((q, qi) => {
                                if (qi < 2) {
                                    if (
                                        q.score == null ||
                                        Number(q.score) === 0
                                    ) {
                                        q.score = 5;
                                    }
                                }
                            });
                            f0.TotalScore = f0.questions.reduce(
                                (a, b) =>
                                    a +
                                    (b.score != null ? Number(b.score) : 0),
                                0
                            );
                        }
                    } else if (
                        preview === 'fitness-final' ||
                        preview === 'section-complete'
                    ) {
                        previewIndex = 0;
                        previewQuestion = 10;
                        const f0 = questions[0];
                        if (f0) {
                            f0.questions.forEach((q) => {
                                if (q.score == null || Number(q.score) === 0) {
                                    q.score = 5;
                                }
                            });
                            f0.TotalScore = f0.questions.reduce(
                                (a, b) => a + Number(b.score),
                                0
                            );
                        }
                    } else if (preview === 'fun-start') {
                        previewIndex = 6;
                        previewQuestion = 0;
                        questions.forEach((f, fi) => {
                            f.questions.forEach((q) => {
                                if (fi < 6) {
                                    if (
                                        q.score == null ||
                                        Number(q.score) === 0
                                    ) {
                                        q.score = 5;
                                    }
                                } else {
                                    q.score = 0;
                                }
                            });
                            f.TotalScore = f.questions.reduce(
                                (a, b) => a + Number(b.score),
                                0
                            );
                        });
                    } else if (
                        preview === 'step1-final' ||
                        preview === 'step1-complete'
                    ) {
                        previewIndex = 7;
                        previewQuestion = 10;
                        questions.forEach((f) => {
                            f.questions.forEach((q) => {
                                if (q.score == null || Number(q.score) === 0) {
                                    q.score = 5;
                                }
                            });
                            f.TotalScore = f.questions.reduce(
                                (a, b) => a + Number(b.score),
                                0
                            );
                        });
                    }
                } catch {
                    /* ignore */
                }

                this.setState({
                    Fs: questions,
                    changeStepIndex: this.props.changeStepIndex,
                    hideNav: this.props.mobile,
                    User: currUser,
                    lastF: userState.areaId + 1,
                    index: previewIndex,
                    currentQuestion: previewQuestion,
                });

                // Skip intro video only when resuming mid-assessment — not merely
                // because an assessment record exists (created on first Step 1 entry).
                const hasAssessmentProgress =
                    Number(userState.areaId) > 0 ||
                    questions.some((f) =>
                        f.questions.some((q) => Number(q.score) > 0)
                    );

                if (hasAssessmentProgress) {
                    this.props.handleChange();
                }
            })
            .catch((error) =>
                this.setState({
                    error,
                    isLoading: false,
                })
            );
    }

    // eslint-disable-next-line class-methods-use-this
    getEventTarget(e) {
        const ev = e || window.event;
        return ev.target || ev.srcElement;
    }

    handleChange = (e) => {
        const ev = e || window.event;
        const target = ev.target || ev.srcElement;
        const index = Number(target.parentElement.parentElement.dataset.key);
        if (!Number.isNaN(index)) {
            this.setState({
                index,
            });
        }
    };

    handleChangeMobile = (e) => {
        const ev = e || window.event;
        const target = ev.target || ev.srcElement;
        const index = Number(target.parentElement.dataset.index);
        if (!Number.isNaN(index)) {
            this.setState({
                index,
            });
        }
    };

    handleChangeIndex = (index) => {
        if (
            index === 7 &&
            this.props.userStatus.userStepId != 6 &&
            !this.props.portalV2
        ) {
            this.props.handleChangeHeader(0);
        }
        if (index === 7 && this.props.userStatus.userStepId === 6) {
            this.props.changeIndexLevelStep(1);
        }
        this.setState({
            index,
        });
    };

    handleChangeConfetti = (confetti) => {
        this.setState({
            confetti,
        });
    };

    handleChangeState = (st) => {
        this.setState(st);
    };

    notifyStep1Reveal = (active) => {
        if (typeof this.props.onStep1Reveal === 'function') {
            this.props.onStep1Reveal(!!active);
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.index !== this.state.index) {
            this.notifyStep1Reveal(this.state.index >= 7);
        }
    }

    componentWillUnmount() {
        this.notifyStep1Reveal(false);
        window.removeEventListener('resize', this.resize.bind(this));
    }

    endStep1 = (state) => {
        const { checkUserSession } = this.context;
        const { token, userId, userStepId } = checkUserSession();

        if (this.props.myr === 1) {
            window.location.replace('/dashboard');
        } else {
            const PostObj = { userId, scores: [] };
            state.Fs.forEach((f) => {
                f.questions.forEach((question) => {
                    PostObj.scores.push({
                        questionId: question.id,
                        score: question.score,
                    });
                });
            });

            this.props.handleChangeHeader(1);
            this.state.changeStepIndex(2);
    }
    };

    resize() {
        this.setState({ hideNav: window.innerWidth <= 760 });
    }
    getTotalAnswers() {
        let answers = 0;
        this.state.Fs.forEach((f) => {
            answers += f.questions.filter((x) => x.score > 0).length;
        });
        return answers;
    }
    render() {
        return (
            <>
                {this.state.User.userStepId === 5 && this.state.index !== 7 && (
                    <section className="midYearReview__headerContainer">
                        <h1>MID-YEAR REVIEW</h1>
                        <h4>QUESTION {this.getTotalAnswers()}/70</h4>
                    </section>
                )}
                {this.state.Fs !== null && (
                    <div className={`${this.state.index!==7?"s12__container":"s12__containerFinal"}`}>
                        {this.state.index < 7 ? (
                            <div className="fnav__container">
                                <Fnav
                                    state={this.state}
                                    handleChange={this.handleChange}
                                    handleChangeState={this.handleChangeState}
                                    portalV2={!!this.props.portalV2}
                                />
                            </div>
                        ) : (
                            <div />
                        )}
                        <div
                            className="fQuestions__container"
                            style={
                                this.state.index >= 7 ? { width: '100%' } : {}
                            }
                        >
                            <SwipeableViews
                                // style={{ height: '100%' }}
                                className="SwipeableViews_Step12"
                                index={this.state.index}
                                onChangeIndex={this.handleChangeIndex}
                                disabled
                            >
                                {this.state.Fs.map((item, i) =>
                                    this.state.index === i ? (
                                        <div
                                            className="questionsPie__container"
                                            key={`questionsPie__container${item.id}`}
                                        >
                                            <Pie
                                                hideNave={this.state.hideNav}
                                                FData={item}
                                                mChange={this.handleChangeState}
                                                iChange={this.handleChangeIndex}
                                                AllState={this.state}
                                                userStatus={this.userStatus}
                                                portalV2={!!this.props.portalV2}
                                            />
                                        </div>
                                    ) : (
                                        <div key={`questionsPie__container${item.id}`}/>
                                    )
                                )}
                                {this.state.index >= 7 ? (
                                    <div className="finalStep1__container">
                                        {!this.props.portalV2 ? (
                                            <Confetti
                                                props={1}
                                                key="9999"
                                                mobile={this.props.mobile}
                                            />
                                        ) : null}
                                        <ContentFinal
                                            state={this.state}
                                            handleChangeIndex={
                                                this.handleChangeIndex
                                            }
                                            endStep1={this.endStep1}
                                            myr={this.props.myr}
                                            mobile={this.props.mobile}
                                            portalV2={!!this.props.portalV2}
                                        />
                                    </div>
                                ) : (
                                    <div />
                                )}
                            </SwipeableViews>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
